// Spotlight — full-viewport SVG that dims everything except a rounded
// rectangle cut out around the active step's anchor. Bordered with the
// primary teal so the user's eye snaps to the focused element.
//
// Ported from the Claude Design handoff (atad-and-or-feature/project/tour.jsx).
// pointer-events:none lets clicks pass through to the underlying app —
// the popover above is the only interactive surface during a tour.

import type { TourRect } from './types';

const PADDING = 8;
const BORDER_COLOR = '#259F93'; // matches tailwind primary
const BACKDROP_COLOR = 'rgba(0,0,0,0.45)';

export type SpotlightProps = {
  rect: TourRect | null;
};

export default function Spotlight({ rect }: SpotlightProps) {
  if (!rect) return null;

  const x = rect.left - PADDING;
  const y = rect.top - PADDING;
  const w = rect.width + PADDING * 2;
  const h = rect.height + PADDING * 2;

  return (
    <svg
      className="fixed inset-0 pointer-events-none z-40"
      width="100%"
      height="100%"
      aria-hidden="true"
    >
      <defs>
        <mask id="atad-tour-spotlight-mask">
          <rect width="100%" height="100%" fill="white" />
          <rect x={x} y={y} width={w} height={h} rx="8" fill="black" />
        </mask>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill={BACKDROP_COLOR}
        mask="url(#atad-tour-spotlight-mask)"
      />
      <rect
        x={x}
        y={y}
        width={w}
        height={h}
        rx="8"
        fill="none"
        stroke={BORDER_COLOR}
        strokeWidth="2"
      />
    </svg>
  );
}
